import React from "react";
import Dashboard from "../Pages/Dashboard";
import Abc from "../Pages/Abc";
import User from "../Pages/User";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Role from "./Role/Role";
import LeaveType from "./LeaveType/LeaveType";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Holiday from "../Pages/Holiday";
import LeaveBalance from "../Pages/LeaveBalance";
import Department from "./Department/Department";
import Division from "./Division/Division";
import Employee from "../Pages/Employee";
import Announcements from "../Pages/Announcement";
import EmployeeSalary from "../Pages/EmployeeSalary";
import Coupon from "../Pages/Coupon";
import Attendances from "../Pages/Attendances";
import LeaveApply from "../Pages/LeaveApply";
import Leaves from "./Leaves/Leaves";
import Salary from "../Pages/Salary";
import SalaryHistoy from "../Pages/SalaryHistoy";

import SalaryView from "../Components/EmployeeSalaryView/SalaryView";
import Resignation from "../Pages/Resignation";
import Product from "../Pages/Product";
import Artisan from "../Pages/Artisan";
import CouponHistory from "../Pages/CouponHistory";
import Travel from "../Pages/Travel";
import CouponValue from "../Pages/CouponValue";
import TravelAllownce from "../Pages/TraelAllownce";
import Notification from "./Notification/Notification";
// ** FOR THE ICON
//https://www.npmjs.com/package/iconsax-react

import {
  ArchiveBox,
  ArchiveTick,
  ArrowForwardSquare,
  Bill,
  Box,
  CalendarEdit,
  CalendarRemove,
  CalendarTick,
  DocumentText,
  DocumentText1,
  GlobalSearch,
  Convert3DCube,
  Gift,
  Home,
  Home2,
  I24Support,
  Location,
  Money,
  Moneys,
  MoneySend,
  NotificationStatus,
  People,
  PercentageSquare,
  Profile,
  Rank,
  ReceiptEdit,
  Setting2,
  SmartCar,
  TableDocument,
  TaskSquare,
  TicketDiscount,
  UserAdd,
  UserCirlceAdd,
  UserSquare,
  UserTag,
  WalletMoney,
  Document,
  CalendarAdd,
  Bezier,
} from "iconsax-react";
import {
  Announcement,
  Engineering,
  Inventory2,
  LocationOn,
  PictureInPicture,
  PictureInPictureAlt,
  PictureInPictureAltSharp,
  Pix,
  ReportOffOutlined,
  RequestQuote,
  Support,
} from "@mui/icons-material";
import Probation from "../Pages/Probation";
import Tds from "../Pages/Tds";
import ItSetup from "../Pages/ItSetup";
import Quotation from "../Pages/Quotation";
import ManagerHrApproval from "./Travel/ManagerHrApproval";
import RegularizeAttendance from "../Pages/RegularizeAttendance";
import List from "./Documents/List";
import TravelExpenses from "../Pages/TravelExpenses";
import TeamExpenses from "../Pages/TeamExpenses";
import AccountantExpanses from "../Pages/AccountantExpanses";
import TeamLeaveRequest from "../Pages/TeamLeaveRequest";
import ProposedManpower from "../Pages/ProposedManpower";
import TeamResignationRequests from "../Pages/TeamResignationRequests";
import TravelDesk from "../Pages/TravelDesk";
import HrAllExpenses from "../Pages/HrAllExpenses";
import TravelExpense from "../Pages/TravelExpense";
import TeamExpense from "../Pages/TeamExpense";
import Vender from "../Pages/Vender";
import Unit from "../Pages/Unit";
import Category from "../Pages/Category";
import SubCategory from "../Pages/SubCategory";
import RawMaterial from "../Pages/RawMaterial";
import Transactions from "../Pages/Transactions";
import PurchaseOrder from "../Pages/PurchaseOrder";
import BatchCreation from "../Pages/BatchCreation";
import BOMCreation from "../Pages/BOMCreation";
import Stock from "../Pages/Stock";
import QCSpecification from "../Pages/QCSpecification";
import PoInvert from "../Pages/Invert";
import CER from "../Pages/CER";
import Installation from "../Pages/Installation";
import Assets from "../Pages/Assets";
import MoveOrder from "../Pages/MoveOrder";
import Subject from "../Pages/Subject";
import MeetingRequest from "../Pages/MeetingRequest";
import PopGift from "../Pages/PopGift";
import Branding from "../Pages/Branding";
import Production from "../Pages/Production";
import BatchRelease from "../Pages/BatchRelease";
import MainCounter from "../Pages/MainCounter";
import ListCounter from "../Pages/ListCounter";

import Distributor from "../Pages/DistributorNetwork";
import DistributorNetwork from "../Pages/DistributorNetwork";
import PriceList from "../Pages/PriceList";
import MarketMaterial from "../Pages/PopGift";

import Orders from "../Pages/Order";

import TechnicalSupport from "../Pages/TechnicalSupport";
import SalesTarget from "../Pages/SalesTarget";
import SampleRequest from "../Pages/SampleRequest";
import OrderClaim from "../Pages/OrderClaim";
import Report from "../Pages/Report";
import FinishGoods from "../Pages/FinishGoods";
import DestinationCenter from "../Pages/DestinationCenter";
import BillingLocation from "../Pages/BillingLocation";
import AttendancesReport from "../Pages/AttendaceReport";
import Others from "../Pages/Others";
import MyBranding from "../Pages/MyBranding";
import MyOthersRequest from "../Pages/MyOthersRequest";
import PopupGiftRequest from "../Pages/PopupGiftRequest";
import DetailCounter from "./Counter/CounterWiseAmountDetail";
import KeyPersonWiseDetail from "./Counter/KeyPersonWiseAmountDetail";
import EmployeeAmountDetail from "./Counter/EmployeeAmountDetail";
export const PrimaryMenu = [
  {
    title: "Dashboard",
    icon: <Home2 className="navicon" />,
    iconHover: <Home2 className="navicon-hover" variant="Bold" />,
    path: "/dashboard",
    cName: "nav-link",
    comp: <Dashboard />,
    showInMenu: true,
  },
  {
    title: "Attendance",
    icon: <CalendarTick className="navicon" />,
    iconHover: <CalendarTick className="navicon-hover" variant="Bold" />,
    path: "/attendances",
    cName: "nav-link",
    comp: <Attendances />,
    showInMenu: true,
  },
  {
    title: "Attendance Report",
    icon: <CalendarAdd className="navicon" />,
    iconHover: <CalendarAdd className="navicon-hover" variant="Bold" />,
    path: "/attendances-report",
    cName: "nav-link",
    comp: <AttendancesReport />,
    showInMenu: true,
  },
  {
    title: "Documents",
    icon: <DocumentText className="navicon" />,
    iconHover: <DocumentText className="navicon-hover" variant="Bold" />,
    path: "/employee-documents",
    cName: "nav-link",
    comp: <List />,
    showInMenu: true,
  },
  {
    title: "Leave Request",
    icon: <CalendarRemove className="navicon" />,
    iconHover: <CalendarRemove className="navicon-hover" variant="Bold" />,
    path: "/leave-request",
    cName: "nav-link",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Your Leave Request",
        path: "/leave-request/your-leave-req",
        cName: "nav-link",
        comp: <LeaveApply />,
        icon: "",
      },
      {
        title: "Team Leave Request",
        path: "/leave-request/team-leave-req",
        cName: "nav-link",
        comp: <TeamLeaveRequest />,
        icon: "",
      },
    ],
  },
  {
    title: "Travel Plan",
    icon: <SmartCar className="navicon" />,
    iconHover: <SmartCar className="navicon-hover" variant="Bold" />,
    path: "/travel",
    cName: "nav-link",
    comp: "",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Your Travel Request",
        path: "/travel/your-travel-req",
        cName: "nav-link",
        comp: <Travel />,
        icon: "",
      },
      {
        title: "Other Travel Request",
        path: "/travel/junior-travel-req",
        cName: "nav-link",
        comp: <ManagerHrApproval />,
        icon: "",
      },
    ],
  },
  {
    title: "Expenses",
    icon: <UserSquare className="navicon" />,
    iconHover: <UserSquare className="navicon-hover" variant="Bold" />,
    path: "/expenses",
    cName: "nav-link",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Your Expenses",
        path: "/expenses/your-expense",
        cName: "nav-link",
        comp: <TravelExpense />,
        icon: "",
      },
      // {
      //   title: "New Expenses",
      //   path: "/expenses/new-expense",
      //   cName: "nav-link",
      //   comp: <TravelExpense />,
      //   icon: "",
      // },
      {
        title: "Team Expenses",
        path: "/expenses/team-expense",
        cName: "nav-link",
        comp: <TeamExpense />,
        icon: "",
      },
      {
        title: "Accountant Expenses",
        path: "/expenses/accountant-expense",
        cName: "nav-link",
        comp: <TeamExpense />,
        icon: "",
      },
      {
        title: "All Expenses",
        path: "/expenses/all-expense",
        cName: "nav-link",
        comp: <TeamExpense />,
        icon: "",
      },
    ],
  },
  {
    title: "Salary",
    icon: <Money className="navicon" />,
    iconHover: <Money className="navicon-hover" variant="Bold" />,
    path: "/employee-salary",
    cName: "nav-link",
    comp: <SalaryView />,
    showInMenu: true,
  },
  {
    title: "Tax & TDS",
    icon: <PercentageSquare className="navicon" />,
    iconHover: <PercentageSquare className="navicon-hover" variant="Bold" />,
    path: "/employee/tds",
    cName: "nav-link",
    comp: <Tds />,
    showInMenu: true,
  },
  {
    title: "Regularization",
    icon: <CalendarTick className="navicon" />,
    iconHover: <CalendarTick className="navicon-hover" variant="Bold" />,
    path: "/regularize-attendances",
    cName: "nav-link",
    comp: <RegularizeAttendance />,
    showInMenu: true,
  },
  {
    title: "Resignation",
    icon: <ReceiptEdit className="navicon" />,
    iconHover: <ReceiptEdit className="navicon-hover" variant="Bold" />,
    path: "/resignation",
    cName: "nav-link",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Apply Resignation",
        path: "/resignation/add-resignation",
        cName: "nav-link",
        comp: <Resignation />,
        icon: "",
      },
      {
        title: "Team Resignation",
        path: "/resignation/team-resignation-requests",
        cName: "nav-link",
        comp: <TeamResignationRequests />,
        icon: "",
      },
    ],
  },
  {
    title: "User",
    icon: <UserSquare className="navicon" />,
    iconHover: <UserSquare className="navicon-hover" variant="Bold" />,
    path: "/user",
    cName: "nav-link",
    comp: <User />,
    showInMenu: true,
  },

  {
    title: "Employee",
    icon: <Profile className="navicon" />,
    iconHover: <Profile className="navicon-hover" variant="Bold" />,
    path: "/employee",
    cName: "nav-link",
    comp: <Employee />,
    showInMenu: true,
  },

  {
    title: "Quotation",
    //title: "Employee",
    icon: <Money className="navicon" />,
    iconHover: <Money className="navicon-hover" variant="Bold" />,
    path: "/quotation",
    cName: "nav-link",
    comp: <Quotation />,

    showInMenu: true,
  },

  // {
  //   title: "Probation Period",
  //   icon: <UserTag className="navicon" />,
  //   iconHover: <UserTag className="navicon-hover" variant="Bold" />,
  //   path: "/probation",
  //   cName: "nav-link",
  //   comp: <Probation />,
  //   showInMenu: true,
  // },

  {
    title: "",
    icon: "",
    path: "/employee/salary",
    cName: "nav-link",
    comp: <EmployeeSalary />,
    showInMenu: false,
  },

  {
    title: "Department",
    icon: <People className="navicon" />,
    iconHover: <People className="navicon-hover" variant="Bold" />,
    path: "/department",
    cName: "nav-link",
    comp: <Department />,
    showInMenu: true,
  },
  {
    title: "Division",
    icon: <Bezier className="navicon" />,
    iconHover: <Bezier className="navicon-hover" variant="Bold" />,
    path: "/division",
    cName: "nav-link",
    comp: <Division />,
    showInMenu: true,
  },
  {
    title: "Designation",
    icon: <UserAdd className="navicon" />,
    iconHover: <UserAdd className="navicon-hover" variant="Bold" />,
    path: "/designation",
    cName: "nav-link",
    comp: <Role />,
    showInMenu: true,
  },

  // {
  //   title: "Pay Slip",
  //   icon: "feed",
  //   path: "/xyz",
  //   cName: "nav-link",
  //   showInMenu: true,
  // },
  // {
  //   title: "Training",
  //   icon: "local_library",
  //   path: "/xyz",
  //   cName: "nav-link",
  //   showInMenu: true,
  // },
  // {
  //   title: "On-Boarding",
  //   icon: "person_add",
  //   path: "/xyz",
  //   cName: "nav-link",
  //   showInMenu: true,
  // },
  // {
  //   title: "Tax & TDS Module",
  //   icon: "percent",
  //   path: "/xyz",
  //   cName: "nav-link",
  //   showInMenu: true,
  // },

  {
    title: "Announcement",
    icon: <NotificationStatus className="navicon" />,
    iconHover: <NotificationStatus className="navicon-hover" variant="Bold" />,
    path: "/announcement",
    comp: <Announcements />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Allownce Master",
    icon: <SmartCar className="navicon" />,
    iconHover: <SmartCar className="navicon-hover" variant="Bold" />,
    path: "/tarvel-allownce",
    comp: <TravelAllownce />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Travel Desk",
    icon: <SmartCar className="navicon" />,
    iconHover: <SmartCar className="navicon-hover" variant="Bold" />,
    path: "/tarvel-desk",
    comp: <TravelDesk />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Proposed Manpower",
    icon: <Engineering className="navicon" />,
    iconHover: <Engineering className="navicon-hover" variant="Bold" />,
    path: "/proposed-manpower",
    comp: <ProposedManpower />,
    cName: "nav-link",
    showInMenu: true,
  },
  // {
  //   title: "Document",
  //   icon: "description",
  //   path: "/xyz",
  //   cName: "nav-link",
  //   showInMenu: true,
  // },

  // {
  //   title: "Artisan",
  //   icon: "groups",
  //   path: "/artisan",
  //   comp: <Artisan />,
  //   cName: "nav-link",
  //   showInMenu: true,
  // },

  // {
  //   title: "Coupon",
  //   icon: "discount",
  //   path: "/coupon-code",
  //   comp: <Coupon />,
  //   cName: "nav-link",
  //   showInMenu: true,
  // },
  {
    title: "Coupon Management",
    icon: <TicketDiscount className="navicon" />,
    iconHover: <TicketDiscount className="navicon-hover" variant="Bold" />,
    path: "/coupon",
    cName: "nav-link has-dropdown",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Artisan",
        path: "/coupon/artisan",
        cName: "nav-link",
        comp: <Artisan />,
        icon: "",
      },
      {
        title: "Coupon",
        path: "/coupon/coupon-code",
        cName: "nav-link",
        comp: <Coupon />,
        icon: "",
      },
      {
        title: "Transactions",
        path: "/coupon/transactions",
        cName: "nav-link",
        comp: <Transactions />,
        icon: "",
      },
      // {
      //   title: "Coupon History",
      //   path: "/coupon/coupon-history",
      //   cName: "nav-link",
      //   comp: <CouponHistory />,
      //   icon: "",
      // },
      // {
      //   title: "Coupon Value",
      //   path: "/coupon/coupon-value",
      //   cName: "nav-link",
      //   comp: <CouponValue />,
      //   icon: "",
      // },
    ],
  },

  {
    title: "Distribution Network",
    icon: <Convert3DCube className="navicon" />,
    iconHover: <Convert3DCube className="navicon-hover" variant="Bold" />,
    path: "/distribution",
    cName: "nav-link has-dropdown",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Distributor",
        path: "/distribution/distributor",
        cName: "nav-link",
        comp: <DistributorNetwork />,
        icon: "",
      },
      {
        title: "Dealer",
        path: "/distribution/dealer",
        cName: "nav-link",
        comp: <DistributorNetwork />,
        icon: "",
      },
      {
        title: "Retailer",
        path: "/distribution/retailer",
        cName: "nav-link",
        comp: <DistributorNetwork />,
        icon: "",
      },
      {
        title: "Key Accounts",
        path: "/distribution/key-accounts",
        cName: "nav-link",
        comp: <DistributorNetwork />,
        icon: "",
      },
      {
        title: "PRO",
        path: "/distribution/pro",
        cName: "nav-link",
        comp: <DistributorNetwork />,
        icon: "",
      },
    ],
  },

  {
    title: "Sales Order Claims",
    icon: <TaskSquare className="navicon" />,
    iconHover: <TaskSquare className="navicon-hover" variant="Bold" />,
    path: "/claim-list",
    comp: <OrderClaim />,
    cName: "nav-link",
    showInMenu: true,
  },

  // {
  //   title: "Price List",
  //   icon: <WalletMoney className="navicon" />,
  //   iconHover: <WalletMoney className="navicon-hover" variant="Bold" />,
  //   path: "/price-list",
  //   comp: <PriceList />,
  //   cName: "nav-link",
  //   showInMenu: true,
  // },
  {
    title: "Product",
    icon: <Box className="navicon" />,
    iconHover: <Box className="navicon-hover" variant="Bold" />,
    path: "/product",
    comp: <Product />,
    cName: "nav-link",
    showInMenu: true,
  },

  {
    title: "It Setup",
    icon: <Setting2 className="navicon" />,
    iconHover: <Setting2 className="navicon-hover" variant="Bold" />,
    path: "/it-setup",
    comp: <ItSetup />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Sales Order",
    icon: <ArchiveBox className="navicon" />,
    iconHover: <ArchiveBox className="navicon-hover" variant="Bold" />,
    path: "/orders",
    comp: <Orders />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Sales Reports",
    icon: <Document className="navicon" />,
    iconHover: <Document className="navicon-hover" variant="Bold" />,
    path: "/reports",
    comp: <Report />,
    cName: "nav-link",
    showInMenu: true,
  },

  {
    title: "Technical Support",
    icon: <Support className="navicon" />,
    iconHover: <Support className="navicon-hover" variant="Bold" />,
    path: "/technical-support",
    comp: <TechnicalSupport />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Sales Target",
    icon: <Rank className="navicon" />,
    iconHover: <Rank className="navicon-hover" variant="Bold" />,
    path: "/sales-target",
    comp: <SalesTarget />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Sample Request",
    icon: <Pix className="navicon" />,
    iconHover: <Pix className="navicon-hover" variant="Bold" />,
    path: "/sample-request",
    comp: <SampleRequest />,
    cName: "nav-link",
    showInMenu: true,
  },
  // {
  //   title: "Pop & Gift",
  //   icon: <Gift className="navicon" />,
  //   iconHover: <Gift className="navicon-hover" variant="Bold" />,
  //   path: "/market-material",
  //   comp: <PopGift />,
  //   cName: "nav-link",
  //   showInMenu: true,
  // },

  {
    title: "Destination Center",
    icon: <Location className="navicon" />,
    iconHover: <Location className="navicon-hover" variant="Bold" />,
    path: "/destination-center",
    comp: <DestinationCenter />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Billing Location",
    icon: <Location className="navicon" />,
    iconHover: <Location className="navicon-hover" variant="Bold" />,
    path: "/billing-location",
    comp: <BillingLocation />,
    cName: "nav-link",
    showInMenu: true,
  },

  {
    title: "Raw Material",
    icon: <Setting2 className="navicon" />,
    iconHover: <Setting2 className="navicon-hover" variant="Bold" />,
    path: "/raw-material",
    comp: <RawMaterial />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Master",
    icon: <Moneys className="navicon" />,
    iconHover: <Moneys className="navicon-hover" variant="Bold" />,
    path: "/master",
    cName: "nav-link has-dropdown",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Unit",
        path: "/master/unit",
        cName: "nav-link",
        comp: <Unit />,
        icon: "",
      },
      {
        title: "Category",
        path: "/master/category",
        cName: "nav-link",
        comp: <Category />,
        icon: "",
      },
      {
        title: "Sub Category",
        path: "/master/sub-category",
        cName: "nav-link",
        comp: <SubCategory />,
        icon: "",
      },
    ],
  },
  {
    title: "Vendor",
    icon: <UserCirlceAdd className="navicon" />,
    iconHover: <UserCirlceAdd className="navicon-hover" variant="Bold" />,
    path: "/vendor",
    comp: <Vender />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Purchase Order",
    icon: <DocumentText1 className="navicon" />,
    iconHover: <DocumentText1 className="navicon-hover" variant="Bold" />,
    path: "/purchase-order",
    comp: <PurchaseOrder />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Invert",
    icon: <Bill className="navicon" />,
    iconHover: <Bill className="navicon-hover" variant="Bold" />,
    path: "/invert",
    comp: <PoInvert />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Installation",
    icon: <Bill className="navicon" />,
    iconHover: <Bill className="navicon-hover" variant="Bold" />,
    path: "/installation",
    comp: <Installation />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Assets",
    icon: <ArchiveBox className="navicon" />,
    iconHover: <ArchiveBox className="navicon-hover" variant="Bold" />,
    path: "/assets",
    comp: <Assets />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Move Order",
    icon: <ArrowForwardSquare className="navicon" />,
    iconHover: <ArrowForwardSquare className="navicon-hover" variant="Bold" />,
    path: "/move-order",
    comp: <MoveOrder />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Stock",
    icon: <TableDocument className="navicon" />,
    iconHover: <TableDocument className="navicon-hover" variant="Bold" />,
    path: "/stock-view",
    comp: <Stock />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Finish Good",
    icon: <TableDocument className="navicon" />,
    iconHover: <TableDocument className="navicon-hover" variant="Bold" />,
    path: "/finish-good",
    comp: <FinishGoods />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Production",
    icon: <Setting2 className="navicon" />,
    iconHover: <Setting2 className="navicon-hover" variant="Bold" />,
    path: "/production",
    cName: "nav-link has-dropdown",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Batch Creation",
        path: "/production/batch-creation",
        cName: "nav-link",
        comp: <BatchCreation />,
        icon: "",
      },
      {
        title: "Bom Creation",
        path: "/production/bom-creation",
        cName: "nav-link",
        comp: <BOMCreation />,
        icon: "",
      },
      {
        title: "Batch Release",
        path: "/production/batch-release",
        cName: "nav-link",
        comp: <BatchRelease />,
        icon: "",
      },
      {
        title: "Production Process",
        path: "/production/production-process",
        cName: "nav-link",
        comp: <Production />,
        icon: "",
      },
    ],
  },
  {
    title: "Marketing",
    icon: <GlobalSearch className="navicon" />,
    iconHover: <GlobalSearch className="navicon-hover" variant="Bold" />,
    path: "/marketing",
    cName: "nav-link has-dropdown",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Subject",
        path: "/marketing/subject",
        cName: "nav-link",
        comp: <Subject />,
        icon: "",
      },
      {
        title: "Meeting",
        path: "/marketing/meeting",
        cName: "nav-link",
        comp: <MeetingRequest />,
        icon: "",
      },
      // {
      //   title: "Your Meeting Request",
      //   path: "/marketing/your-meeting-request",
      //   cName: "nav-link",
      //   comp: <MeetingRequest />,
      //   icon: "",
      // },
      // {
      //   title: "Team Meeting Request",
      //   path: "/marketing/team-meeting-request",
      //   cName: "nav-link",
      //   comp: <MeetingRequest />,
      //   icon: "",
      // },
      // {
      //   title: "Meeting Request",
      //   path: "/marketing/meeting-request",
      //   cName: "nav-link",
      //   comp: <MeetingRequest />,
      //   icon: "",
      // },
      {
        title: "Counter",
        path: "/marketing/counter",
        cName: "nav-link",
        comp: <ListCounter />,
        icon: "",
      },
      {
        title: "Pop Master",
        path: "/marketing/pop-gift",
        comp: <PopGift />,
        cName: "nav-link",
        icon: "",
      },
      {
        title: "Direct Pop",
        path: "/marketing/popup-gift-request",
        comp: <PopupGiftRequest />,
        cName: "nav-link",
        icon: "",
      },
      {
        title: "Branding",
        path: "/marketing/branding",
        comp: <Branding />,
        cName: "nav-link",
        icon: "",
      },
      {
        title: "My Branding",
        path: "/marketing/my-branding",
        comp: <MyBranding />,
        cName: "nav-link",
        icon: "",
      },
      {
        title: "Others",
        path: "/marketing/others",
        comp: <Others />,
        cName: "nav-link",
        icon: "",
      },
      {
        title: "My Others",
        path: "/marketing/my-others",
        comp: <MyOthersRequest />,
        cName: "nav-link",
        icon: "",
      },
    ],
  },
  {
    title: "",
    icon: "",
    iconHover: "",
    path: "/marketing/add-counter",
    comp: <MainCounter />,
    cName: "nav-link",
    showInMenu: false,
  },

  {
    title: "",
    icon: "",
    iconHover: "",
    path: "/marketing/counter-detail/:id",
    comp: <DetailCounter />,
    cName: "nav-link",
    showInMenu: false,
  },
  {
    title: "",
    icon: "",
    iconHover: "",
    path: "/marketing/keyPerson-wise-detail/:id",
    comp: <KeyPersonWiseDetail />,
    cName: "nav-link",
    showInMenu: false,
  },
  {
    title: "",
    icon: "",
    iconHover: "",
    path: "/marketing/employe-counter-detail/:id",
    comp: <EmployeeAmountDetail />,
    cName: "nav-link",
    showInMenu: false,
  },
  {
    title: "QC Specification",
    icon: <ArchiveTick className="navicon" />,
    iconHover: <ArchiveTick className="navicon-hover" variant="Bold" />,
    path: "/qc-specification",
    comp: <QCSpecification />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "CER",
    icon: <MoneySend className="navicon" />,
    iconHover: <MoneySend className="navicon-hover" variant="Bold" />,
    path: "/capital-expenditure-requistion",
    comp: <CER />,
    cName: "nav-link",
    showInMenu: true,
  },
  {
    title: "Payroll Management",
    icon: <Moneys className="navicon" />,
    iconHover: <Moneys className="navicon-hover" variant="Bold" />,
    path: "/salary",
    cName: "nav-link has-dropdown",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Generate Salary",
        path: "/salary/employee-salary",
        cName: "nav-link",
        comp: <Salary />,
        icon: "",
      },
      {
        title: "Salary History",
        path: "/salary/salary-history",
        cName: "nav-link",
        comp: <SalaryHistoy />,
        icon: "",
      },
    ],
  },
  {
    title: "Leave & Holidays",
    icon: <CalendarEdit className="navicon" />,
    iconHover: <CalendarEdit className="navicon-hover" variant="Bold" />,
    path: "/leave",
    cName: "nav-link has-dropdown",
    comp: "",
    showInMenu: true,
    submenu: [
      {
        title: "Leave Type",
        path: "/leave/leave-type",
        cName: "nav-link",
        comp: <LeaveType />,
        icon: "",
      },
      {
        title: "Holiday",
        path: "/leave/holiday",
        cName: "nav-link",
        comp: <Holiday />,
        icon: "",
      },
      {
        title: "Leave Balance",
        path: "/leave/leave-balance",
        cName: "nav-link",
        comp: <LeaveBalance />,
        icon: "",
      },

      {
        title: "Leaves",
        path: "/leave/leaves",
        cName: "nav-link",
        comp: <Leaves />,
        icon: "",
      },
    ],
  },
  {
    title: "Notifications",
    icon: <NotificationStatus className="navicon" />,
    iconHover: <NotificationStatus className="navicon-hover" variant="Bold" />,
    path: "/notifications",
    comp: <Notification />,
    cName: "nav-link",
    showInMenu: false,
  },
];

export default PrimaryMenu;
